import { Typography } from "@mui/material";

const Headers = ({
  children,
  fontSize,
  style,
}: {
  children: string;
  fontSize?: number;
  style?: any;
}) => {
  return (
    <Typography
      variant="h3"
      fontSize={fontSize ?? 20}
      className="font-yekan-fat"
      sx={style}
    >
      {children}
    </Typography>
  );
};

export default Headers;
